import script from "./AppCustomTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppCustomTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./AppCustomTextarea.vue?vue&type=style&index=0&id=b9793996&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9793996"]])

export default __exports__